import { useMemo, useRef } from "react";
import BalanceCard from "../balancecard/BalanceCard";
import { Select } from "../index";
import { SmallUpArrow } from "../svg-organizer/SvgOrganizer";
import { useAccounts } from "../../data/live";
import { useWalletEquivalent } from "../../data/walletEquivalent";
import {
  CURRENCY_FLAG,
  CURRENCY_NAME,
  formatCurrencyAmount,
  sortByDashboardCurrencyOrder,
} from "../../utils/currencyMeta";


const CarouselArrowIcon = ({ direction }) => (
  <svg
    aria-hidden="true"
    className="dashboard-carousel-icon"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d={direction === "previous" ? "M15 18l-6-6 6-6" : "M9 6l6 6-6 6"}
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const TotalAvailableBalanceSection = () => {
  const { accounts, source } = useAccounts();
  const {
    converting,
    displayCurrency,
    displayCurrencyOptions,
    formattedTotal,
    openAccounts,
    setDisplayCurrency,
    unconvertible,
    totalUnavailable,
  } = useWalletEquivalent(accounts);
  const carouselRef = useRef(null);
  const sortedAccounts = useMemo(
    () =>
      sortByDashboardCurrencyOrder(openAccounts),
    [openAccounts]
  );

  const liveCards = sortedAccounts.map((a) => ({
    curenncyName: CURRENCY_NAME[a.currency] || a.currency,
    currency: a.currency,
    amount1: formatCurrencyAmount(a.balance, a.currency),
    amount2: Number(a.availableBalance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    percentage1: "-",
    percentage2: Math.min(100, Math.round((Number(a.availableBalance) / Math.max(Number(a.balance), 1)) * 100)),
    flagIcon: CURRENCY_FLAG[a.currency] || null,
    iban: a.iban,
    accountId: a.id,
  }));
  const scrollWallets = (direction) => {
    carouselRef.current?.scrollBy({
      left: direction * 272,
      behavior: "smooth",
    });
  };

  return (
     <div className="dashboard-balance-panel d-flex flex-column">
      <div className="dashboard-balance-header">
        <h4 className="mb-0">
          Total Available Balance
          <span className="fs-6 ms-2" style={{ color: "var(--text-muted)" }}>
            (in All Currencies)
          </span>
        </h4>
        <div className="dashboard-balance-control d-flex gap-2 align-items-center">
          <Select
            value={displayCurrency}
            defaultValue="AUD"
            className="rounded-pill"
            options={displayCurrencyOptions}
            selectStyle={{ width: "90px" }}
            popupClassName="bg-white"
            onChange={(e) => setDisplayCurrency(e.target.value)}
          />

          <span className="fw-semibold fs-4" title={
            unconvertible.length
              ? `No ${displayCurrency} exchange rate available for ${unconvertible.join(", ")}`
              : undefined
          }>
            {converting ? "…" : formattedTotal}
          </span>
          {!converting && unconvertible.length > 0 && (
            /* Say why, rather than letting a dash or a short total look like
               the customer's money is missing. */
            <span
              className="fs12px"
              style={{ color: "#9C6A12" }}
              role="status"
            >
              {totalUnavailable
                ? `No ${displayCurrency} rate available`
                : `${unconvertible.join(", ")} not included, no ${displayCurrency} rate`}
            </span>
          )}
          <div
            className="d-flex gap-1 align-items-center fs-6"
            style={{ color: "#1BBB6B" }}
          >
            <span>
              <SmallUpArrow />
            </span>
            <span>0%</span>
          </div>
          <button
            type="button"
            className="dashboard-carousel-btn"
            aria-label="Previous currencies"
            onClick={() => scrollWallets(-1)}
          >
            <CarouselArrowIcon direction="previous" />
          </button>
          <button
            type="button"
            className="dashboard-carousel-btn"
            aria-label="Next currencies"
            onClick={() => scrollWallets(1)}
          >
            <CarouselArrowIcon direction="next" />
          </button>
        </div>
      </div>
      <div className="dashboard-wallet-carousel" ref={carouselRef}>
        {liveCards.length === 0 && source === "api" ? (
          <span className="fs14px" style={{ color: "var(--text-muted)" }}>
            No wallets yet. Create one from Mobile Wallet > Add Wallet.
          </span>
        ) : (
          liveCards.map((data, key) => <BalanceCard key={key} cardData={data} />)
        )}
      </div>
    </div>
  );
};

export default TotalAvailableBalanceSection;


